(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ozzy-lounge-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initCalendars = (scope) => {
    if (!scope || !scope.querySelectorAll) return;
    scope.querySelectorAll('[data-oz-calendar]').forEach((calendar) => {
      if (calendar.dataset.initialized === 'true') return;
      const section = calendar.closest('[data-oz-events-section]');
      const dayGrid = calendar.querySelector('[data-oz-days]');
      const monthLabel = calendar.querySelector('[data-oz-month]');
      const eventList = section && section.querySelector('[data-oz-event-list]');
      if (!section || !dayGrid || !monthLabel || !eventList) return;
      calendar.dataset.initialized = 'true';

      const eventItems = Array.from(eventList.querySelectorAll('[data-oz-event]'));
            // ISO dates sort chronologically, regardless of the theme editor block order.
      eventItems.sort((a, b) => (a.getAttribute('data-date') || '9999-99-99').localeCompare(b.getAttribute('data-date') || '9999-99-99'));
      const listEnd = eventList.querySelector('[data-oz-no-events]');
      eventItems.forEach((item) => eventList.insertBefore(item, listEnd));
const validEvents = eventItems.map((item) => ({
        element: item,
        date: item.getAttribute('data-date') || ''
      })).filter((event) => /^\d{4}-\d{2}-\d{2}$/.test(event.date));

      const listTitle = eventList.querySelector('[data-oz-list-title]');
      const eventCount = eventList.querySelector('[data-oz-count]');
      const emptyState = eventList.querySelector('[data-oz-no-events]');
      const getBaliToday = () => new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Makassar', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date()).reduce((result, part) => {
        if (part.type !== 'literal') result[part.type] = part.value;
        return result;
      }, {});
      let baliToday = getBaliToday();
      let year = Number(baliToday.year);
      let month = Number(baliToday.month) - 1;
      let selectedDate = '';

      const monthKey = () => year + '-' + String(month + 1).padStart(2, '0');
      const monthName = () => new Intl.DateTimeFormat('en', { month: 'long', year: 'numeric' }).format(new Date(year, month, 1));

      const renderEvents = () => {
        const key = monthKey();
        const todayKey = baliToday.year + '-' + baliToday.month + '-' + baliToday.day;
        const matchesList = (date) => date.slice(0, 7) === key && (selectedDate ? date === selectedDate : date >= todayKey);
        const visible = validEvents.filter((event) => matchesList(event.date));
        eventItems.forEach((item) => {
          const date = item.getAttribute('data-date') || '';
          item.hidden = !matchesList(date);
        });
        if (listTitle) listTitle.textContent = selectedDate ? 'Events on ' + new Intl.DateTimeFormat('en', { month: 'long', day: 'numeric' }).format(new Date(year, month, Number(selectedDate.slice(8, 10)))) : 'Events in ' + monthName();
        if (eventCount) eventCount.textContent = visible.length + (visible.length === 1 ? ' event' : ' events') + (selectedDate ? ' on this day' : ' this month');
        if (emptyState) emptyState.hidden = visible.length > 0;
      };

      const renderCalendar = () => {
        monthLabel.textContent = monthName();
        dayGrid.replaceChildren();
        const firstWeekday = new Date(year, month, 1).getDay();
        const daysInMonth = new Date(year, month + 1, 0).getDate();
        const monthEvents = validEvents.filter((event) => event.date.slice(0, 7) === monthKey());
        const eventDates = new Set(monthEvents.map((event) => event.date));
        const todayKey = baliToday.year + '-' + baliToday.month + '-' + baliToday.day;

        for (let i = 0; i < firstWeekday; i += 1) {
          const blank = document.createElement('span');
          blank.className = 'oz-calendar__blank';
          blank.setAttribute('aria-hidden', 'true');
          dayGrid.appendChild(blank);
        }
        for (let day = 1; day <= daysInMonth; day += 1) {
          const key = year + '-' + String(month + 1).padStart(2, '0') + '-' + String(day).padStart(2, '0');
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'oz-calendar__day';
          button.setAttribute('role', 'gridcell');
          button.setAttribute('aria-pressed', selectedDate === key ? 'true' : 'false');
          const eventTotal = monthEvents.filter((event) => event.date === key).length;
          const labelDate = new Intl.DateTimeFormat('en', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' }).format(new Date(year, month, day));
          button.setAttribute('aria-label', labelDate + (eventTotal ? ', ' + eventTotal + (eventTotal === 1 ? ' event' : ' events') : ', no events'));
          if (eventDates.has(key)) button.classList.add('has-events');
          if (key === todayKey) button.classList.add('is-today');
          if (selectedDate === key) button.classList.add('is-selected');
          const number = document.createElement('span');
          number.textContent = String(day);
          button.appendChild(number);
          button.addEventListener('click', () => {
            selectedDate = selectedDate === key ? '' : key;
            renderCalendar();
            renderEvents();
          });
          dayGrid.appendChild(button);
        }
        const usedCells = firstWeekday + daysInMonth;
        for (let i = usedCells; i < 42; i += 1) {
          const blank = document.createElement('span');
          blank.className = 'oz-calendar__blank';
          blank.setAttribute('aria-hidden', 'true');
          dayGrid.appendChild(blank);
        }
        renderEvents();
      };

      calendar.querySelector('[data-oz-prev]').addEventListener('click', () => {
        month -= 1;
        if (month < 0) { month = 11; year -= 1; }
        selectedDate = '';
        renderCalendar();
      });
      calendar.querySelector('[data-oz-next]').addEventListener('click', () => {
        month += 1;
        if (month > 11) { month = 0; year += 1; }
        selectedDate = '';
        renderCalendar();
      });
      renderCalendar();
      const refreshDate = () => {
        if (!calendar.isConnected) {
          clearInterval(dateTimer);
          document.removeEventListener('visibilitychange', refreshDate);
          return;
        }
        const nextToday = getBaliToday();
        if (nextToday.year + nextToday.month + nextToday.day !== baliToday.year + baliToday.month + baliToday.day) {
          baliToday = nextToday;
          renderCalendar();
        }
      };
      const dateTimer = setInterval(refreshDate, 60000);
      document.addEventListener('visibilitychange', refreshDate);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCalendars(document), { once: true });
  } else {
    initCalendars(document);
  }
  document.addEventListener('shopify:section:load', (event) => initCalendars(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
